<template>
  <div>
    <div class="v_mainBox">
      <van-form @submit="onSubmit" @failed="onFailed">
        <div class="van-box">
          <div class="van-line2">
            <!-- 备注内容  -->
            <van-field v-model="content" rows="2" autosize type="textarea" maxlength="60"
                       placeholder="对订单进行备注，有助于工作人员了解您的需求，为您提供更好服务哦~" show-word-limit
                       :rules="[{ validator, message: '请输入正确内容' }]"/>
          </div>
        </div>
        <div style="margin: 16px;">
          <van-button round block type="primary" icon="success" native-type="submit" :loading="loading"
                      loading-text="保存中...">保存
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import carInspectionOrder from "@/api/carInspectionOrder";

export default {
  name: "remark",
  data() {
    return {
      orderId: null,
      content: '',
      loading: false,
    };
  },
  created() {
    this.orderId = this.$route.query.orderId
    this.content = this.$route.query.userRemark
  },
  methods: {
    goBack() {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
        return false
      } else {
        this.$router.go(-1)
      }
    },
    /**
     * 表单校验成功
     */
    onSubmit() {
      this.loading = true
      const toast = this.$toast.loading({
        message: '提交中...',
        forbidClick: true,
      });
      const orderEntity = {}
      orderEntity.id = this.orderId
      orderEntity.userRemark = this.content
      carInspectionOrder.addUserRemark(orderEntity).then(res => {
        // eslint-disable-next-line no-console
        console.log(res)
        this.$notify({type: 'success', message: '保存成功\n两秒后跳转'});
        toast.clear()
        setTimeout(() => {
          this.$router.push({path: '/order'})
        }, 2000);
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
        toast.clear()
      })
    },
    /**
     * 表单校验失败
     * @param errorInfo
     */
    onFailed(errorInfo) {
      // eslint-disable-next-line no-console
      console.log('failed', errorInfo);
      this.$notify({type: 'warning', message: '请检查信息是否填写完整'});
    },
    // 校验函数返回 true 表示校验通过，false 表示不通过
    validator(val) {
      return val !== '';
    }
  }
}
</script>

<style scoped>
.v_mainBox {
  width: 100%;
  padding-top: 50px;
}

.van-box {
  width: 100%;
  margin: auto;
  height: auto;
  display: block;
  font-size: 14px;
}

/*好评星星*/
.van-line1 {
  width: 100%;
  border-bottom: 5px solid #eee;
  padding-bottom: 5px;
}

.van-line1 p {
  width: 90%;
  margin: 0 auto;
  height: 25px;
  line-height: 25px;
}

.van-line1 .van-name {
  height: 40px;
  line-height: 40px;
  font-weight: bold;
}

.van-line1 .van-pf span {
  display: inline-block;
  width: 12%;
}

/*输入文字内容*/
.van-line2 {
  width: 100%;
  height: auto;
  display: block;
  border-bottom: 5px solid #eee;
}

.van-cell {
  width: 90%;
  margin: 10px auto 0 auto !important;
  padding: 0 !important;
  min-height: 90px !important;
  font-size: 13px;
  line-height: 25px !important;
}


.van-cell::after {
  border: none !important;
}

.van-txt {
  width: 90%;
  margin: auto;
  font-size: 12px;
  color: #888;
}

.van-button--primary {
  background-color: #3778d0 !important;
  border: 1px solid #3778d0 !important;
}
</style>
